import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import getLanguage from './utils/language';

const resources = {
    my: {
        translation: {
            'common.country': 'နိုင်ငံ',
            'country.myanmar': 'မြန်မာ',
            'country.cambodia': 'ကမ္ဘောဒီးယား',
            'common.international transfer': 'ထရူးမန်းနီးထရန်စဖား',
            'common.add money': 'ပိုက်ဆံသွင်းမည်',
            'common.maybe later': 'နောက်မှပြုလုပ်မည်',
            'common.accept': 'လက်ခံခြင်း',
            'common.cancel': 'ပယ်ဖျက်ခြင်း',
            'common.confirm': 'အတည်ပြုသည်',
            'common.ok': 'အိုကေ',
            'common.close': 'ပိတ်မည်',
            'common.receiver': 'လက်ခံသူ',
            'common.switch': 'ပြောင်းမည်',
            'common.continue': 'ဆက်လက်လုပ်ဆောင်မည်',
            'common.terms and conditions': 'စည်းကမ်းချက်များ',
            'common.receiver details': 'ငွေလက်ခံမည့်သူအချက်အလက်',
            'common.sender details': 'ငွေလွှဲသူအချက်အလက်',
            'common.receiver mobile number': 'ဖုန်းနံပါတ်',
            'common.mobile number': 'ဖုန်းနံပါတ်',
            'common.fullname': 'နာမည်အပြည့်အစုံ',
            'common.fullname (myanmar)': 'နာမည်အပြည့်အစုံ (မြန်မာဘာသာ)',
            'common.fullname (english)': 'နာမည်အပြည့်အစုံ (အင်္ဂလိပ်ဘာသာ)',
            'common.firstname (myanmar)': 'ပထမနာမည် (မြန်မာဘာသာ)',
            'common.lastname (myanmar)': 'နောက်ဆုံးနာမည် (မြန်မာဘာသာ)',
            'common.firstname (english)': 'ပထမနာမည် (အင်္ဂလိပ်ဘာသာ)',
            'common.lastname (english)': 'နောက်ဆုံးနာမည် (အင်္ဂလိပ်ဘာသာ)',
            'common.national id number': 'မှတ်ပုံတင်အမှတ်',
            'common.address': 'နေရပ်လိပ်စာ',
            'common.address no., building, road': 'အမှတ်, တိုက်နံပါတ်, လမ်း',
            'common.state, city, township': 'ရပ်ကွက်/မြို့နယ်, ပြည်နယ်/တိုင်း',
            'common.exchange rate': 'ငွေစျေး',
            'common.transfer fee': 'ဝန်ဆောင်ခ',
            'common.total amount': 'စုစုပေါင်းပမာဏ',
            'common.error code': 'Error code',
            'common.search': 'ရှာဖွေမည်',
            'common.back to home page': 'ပင်မစာမျက်နှာသို့ သွားမည်',

            'placeholder.please select': 'ရွေးချယ်ပါ',
            'placeholder.enter receiver details': 'ငွေလက်ခံသူအချက်အလက်အား ဖြည့်သွင်းပါ',
            'placeholder.first name (english)': 'နောက်ဆုံးစာလုံးမှလွဲ၍ရှေ့စာလုံးအကုန်',
            'placeholder.last name (english)': 'နောက်ဆုံးစာလုံး',
            'placeholder.mobile number': '{{from}} လုံးမှ {{to}} လုံး',
            'placeholder.myanmar national id number': 'မှတ်ပုံတင်နောက်ဆုံး ဂဏန်း 6လုံး',
            'placeholder.cambodia national id number': '',

            'validate.required input': 'ကျေးဇူးပြု၍ ဖြည့်ပါ {{field}}',
            'validate.required select': 'ရွေးချယ်ပါ {{field}}',
            'validate.number only': 'Only numeric',
            'validate.cambodia minimum destination amount': 'The amount must not be less than {{value}} KHR',
            'validate.cambodia maximum destination amount': 'The amount must not be over {{value}} KHR',
            'validate.cambodia minimum amount': 'The amount must not be less than {{value}} THB',
            'validate.cambodia maximum amount': 'The amount must not be over {{value}} THB',
            'validate.myanmar minimum destination amount': 'ပမာဏသည် {{value}} ကျပ် အောက်လျော့၍ မရပါ',
            'validate.myanmar maximum destination amount': 'ပမာဏသည် {{value}} ကျပ် ထက်ကျော်၍မရပါ',
            'validate.myanmar minimum amount': 'ပမာဏသည် 1 ဘတ် အောက်လျော့၍ မရပါ',
            'validate.myanmar maximum amount': 'ပမာဏသည် 30,000 ဘတ် ထက်ကျော်၍မရပါ',

            'validate.only english alphabet': 'အင်္ဂလိပ်စာလုံးသာ',
            'validate.only english alphabet and symbol': 'Only english alphabet and symbol',
            'validation.required digits': 'ဂဏန်း {{value}}လုံးအထိရှိရမည်',
            'validation.required digits between': '{{from}} လုံးမှ {{to}} လုံးအထိရှိရမည်',

            'notify page.just one more step': 'နောက်ထပ်တစ်ဆင့်',
            'notify page.if this is your first time using this service, please verify your identity with truemoney transfer staff first':
                'သင်သည် ဝန်ဆောင်မှုအား ပထမဆုံးအကြိမ်အသုံးပြုခြင်းဖြစ်ပါက ထရူးမန်းနီးမှ ဝန်ထမ်းနှင့်\nအရင်ဆုံးအတည်ပြုပေးရပါမည်',
            'notify page.please prepare these documents': 'လိုအပ်သောစာရွက်စာတမ်းများ',
            'notify page.your passport': 'ပတ်စပို့(စ်)',
            'notify page.your work permit': 'အလုပ်ပါမစ်',
            'notify page.chat with staff': 'ဝန်ထမ်းများနှင့် စကားပြောပါ',
            'notify page.search truemoney transfer locations': 'တည်နေရာရွေးချယ်ပါ',
            'fund in guide page.transferring money to your family is easy, with no fees!':
                'ဝန်ဆောင်ခမပါဘဲ မိသားစုဆီသို့ငွေလွှဲခြင်းမှာ ယခုကဲ့သို့ မလွယ်ကူခဲ့ပါ',
            'fund in guide page.add money to your wallet': 'ဝေါလပ်ထဲသို့ ပိုက်ဆံသွင်းပါ',
            'fund in guide page.add money': 'ပိုက်ဆံသွင်းမည်',
            'fund in guide page.maybe later': 'နောက်မှပြုလုပ်မည်',
            'transfer page.wallet balance': 'လက်ကျန်ငွေ',
            'transfer page.add': 'ပေါင်းထည့်မည်',
            'transfer page.destination country': 'လွှဲမည့်နိုင်ငံ',
            'transfer page.amount to receive': 'ငွေလက်ခံမည့်ပမာဏ',
            'transfer page.amount to send': 'လွှဲပြောင်းမည့်ပမာဏ',
            'transfer page.the exchange rate may change while making a transaction': 'ငွေစျေးအပြောင်းအလဲရှိနိုင်ပါသည်',
            'transfer page.transfer purpose': 'ငွေလွှဲရန် ရည်ရွယ်ချက်',
            'transfer page.no transfer fees': 'ဝန်ဆောင်ခ အခမဲ့',
            'transfer page.you can transfer 50 times per month': 'သင်သည် တရက်လျှင် အကြိမ် 50 ငွေလွှဲနိုင်သည်',
            'transfer page.money transfer license number': 'ငွေလွှဲလိုင်စင်အမှတ်',
            'document expired page.your verification documents have expired': 'သင်အတည်ပြုထားသောအချက်အလက်များသက်တမ်းကုန်ဆုံးနေပါသည်',
            'document expired page.description':
                'Wallet သုံးစွဲသူသည် ၎င်းတို့သက်တမ်းကုန်သွားသည်နှင့် စာရွက်စာတမ်းများကို TrueMoney အပ်ပလီကေးရှင်း မှတစ်ဆင့် အပ်ဒိတ်လုပ်ရမည်ဖြစ်သည်။  ပိုမိုသိရှိလိုပါက TrueMoney Customer Care 1240 သို့ ဆက်သွယ်ပါ။',
            'summary page.this amount and exchange rate will be reserved at this step':
                'ဤငွေပမာဏနှင့်ငွေလဲလှယ်နှုန်းကိုဤအဆင့်တွင်ကြိုတင်သတ်မှတ်ထားပါလိမ့်မည်။',

            'error page.transfer failed': 'ငွေလွှဲမှုမအောင်မြင်ပါ',
            'error page.we will refund your money to your truemoney wallet immediately. please transfer again.':
                'သင့်TrueMoneyဝေါလပ်ထဲသို့ ချက်ချင်းငွေပြန်အမ်းပါမည်။ ကျေးဇူးပြု၍ ပြန်လုပ်ပါ',
            'error page.sorry, the information used for transferring does not meet the criteria to make a transaction. please contact truemoney customer care, call 1240 ext 4.':
                'ဆောရီးပါ။ ငွေလွှဲမှုလုပ်ဆောင်ရန်အတွက် လိုအပ်သည့်အချက်အလက်များသည် စံချိန်စံညွှန်းများနှင့်မကိုက်ညီသဖြင့် လုပ်ဆောင်၍မရပါ။ ကျေးဇူးပြု၍ TrueMoney အသုံးပြုသူစောင့်ရှောက်မှု ဖုန်း 1240 လိုင်းခွဲ 4 သို့ဆက်သွယ်ပါ',
            'error maintenance page.system is temporarily unavailable': 'ယာယီအသုံးပြု၍မရနိုင်ပါ။',
            'error maintenance page.we’re working to fix the problem.we’ll be up and running soon.please try again later.':
                'ကျနော်တို့ပြtheနာကိုပြုပြင်နေကြသည်\nကျေးဇူးပြုပြီးခဏစောင့်ပါ\nတဖန်စာရင်းကိုလုပ်ပါ',
            'error maintenance page.sorry, our truemoney transfer service is now temporary unavailable. our service will resume shortly.':
                'တောင်းပန်ပါသည်။ ထရူးမန်းနီးထရန်စဖား ဝန်ဆောင်မှုအား ခေတ္တယာယီအသုံးပြုလို့မရနိုင်ပါ။ မကြာမီပြန်လည်အသုံးပြုနိုင်မည်ဖြင့်ပါသည်။',
            'error.cannot make a transaction': 'လွှဲပြောင်းမှု ပြုလုပ်၍မရပါ',
            'error.receiver id is not valid': 'receiver id is not valid',
            'error.transfer limit amount receiver title': 'လွှဲပြောင်း၍မရပါ။',
            'error.transfer limit amount receiver description':
                'လက်ခံသူသည် ငွေလက်ခံသည့်နိုင်ငံ၏ စည်းမျဉ်းအရ သတ်မှတ်ထားသည့် အမြင့်ဆုံးပမာဏသို့ ရောက်ရှိနေပါသည် (တစ်လလျှင် {{limit}} MMK)။ ကျေးဇူးပြု၍ နောက်လတွင် ငွေလွှဲပေးပါ။',
            'error.transfer amount is over limit':
                'သတ်မှတ်ထားသော ပမာဏထက်ကျော်လွန်နေပါသည်။ တစ်ခါလွှဲလျှင် ဘတ် {{maximumTransferAmount}} အထိလွှဲနိုင်သည်။ တစ်လလျှင် ဘတ် {{monthlyLimit}} သာလွှဲနိုင်သည်။',
            'error.reached number of times per month': 'သင်သည် သတ်မှတ်ထားသော ငွေလွှဲနိုင်သည့်အကြိမ်ရေသို့ ရောက်ရှိပြီးပါပြီ',
            'error.can transfer only 50 times per month MM':
                'သင််သည် TrueMoney Wallet မှတဆင့် တလလျှင် အကြိမ် 50 နှင့် TrueMoney Transfer ဆိုင်များမှ တလလျှင် အကြိမ် 50 ငွေလွှဲနိုင်ပါသည်။ ကျေးဇူးပြု၍ နောက်လများမှ ထပ်မံငွေလွှဲပါ။',
            'error.can transfer only 50 times per month KH':
                'သင််သည် TrueMoney Wallet မှတဆင့် တလလျှင် အကြိမ် 50 နှင့် TrueMoney Transfer ဆိုင်များမှ တလလျှင် အကြိမ် 50 ငွေလွှဲနိုင်ပါသည်။ ကျေးဇူးပြု၍ နောက်လများမှ ထပ်မံငွေလွှဲပါ။',
            'error version page.unable to process': 'ဆက်လက်လုပ်ဆောင်၍မရပါ',
            'error version page.please update TrueMoney Wallet application to the latest version and try to open the app again.':
                'ကျေးဇူးပြု၍ TrueMoneyဝေါလပ် အပ်ပလီကေးရှင်းကို နောက်ဆုံး version ထိ updateလုပ်ပြီး appထဲပြန်ဝင်ပါ။',
            'error version page.please update the OS of your device and Chrome (if any) to the latest version and try to open the app again.':
                'ကျေးဇူးပြု၍ဖုန်းနှင့်Chrome တို့၏နောက်ဆုံးversion (ရှိလျှင်) updateလုပ်ပြီး appထဲပြန်ဝင်ပါ။',
            'error insufficient document page.insufficient document': 'စာရွက်စာတမ်း မလုံလောက်ပါ',
            'error insufficient document page.You need to update new supporting document ! Contact customer care 1240#4 for more information':
                'သင်​၏ အထောက်အကူပြုစာရွက်စာတမ်းအသစ်ကို အပ်ဒိတ်လုပ်ရန် လိုအပ်ပါသည်။ ! နောက်ထပ်အချက်အလက်များသိရန်အတွက် ကောစင်တာ 1240 လိုင်းခွဲ 4 သို့ ဆက်သွယ်ပါ။',

            'error update information page.we need your updated information': 'သင်၏ update အချက်အလက်များကို ကျွန်ုပ်တို့ လိုအပ်ပါသည်',
            'error update information page.please contact truemoney customer care at 1240 to update your personal information':
                'ကျေးဇူးပြု၍ TrueMoney အသုံးပြုသူစောင့်ရှောက်မှု 1240 သို့ ဆက်သွယ်ပြီး သင်၏ ကိုယ်ရေးကိုယ်တာအချက်အလက်များအား update လုပ်ပေးပါ။',
            'error invalid national id number': 'နိုင်ငံသားစီစစ်ရေးနံပါတ် ထည့်နည်းမမှန်ကန်ပါ။',
            'error invalid national id number format': 'ကျေးဇူးပြု၍ သတ်မှတ်ထားသည့် 00/xxx(x)000000 ထည့်ပါ။ ဥပမာ၊ 10/NaMaNa(နိုင်)123456',
            'error value of region code is not valid': 'ဒေသကုဒ် မကိုက်ညီပါ။',
            'error value of region code and region name are not matched': 'မြို့နယ်အတိုကောက် မကိုက်ညီပါ။',
            'error value of region name is not valid': 'မြို့နယ်အတိုကောက် မကိုက်ညီပါ။',
            'error value of type of ID is not valid': 'အိုင်ဒီ အမျိုးအစား တူညီမှုမရှိပါ။',
            'error please make sure you have entered correct and complete information to transfer and then try again':
                'လွှဲပြောင်းရန် မှန်ကန်ပြီး ပြည့်စုံသော အချက်အလက်ကို သင်ထည့်သွင်းထားကြောင်း သေချာစေပြီးနောက် ထပ်စမ်းကြည့်ပါ။',

            'marketing page.the easiest way to transfer your money in real-time to myanmar with no fees':
                'သင်၏ငွေများကိုအချိန်နှင့်တပြေးညီမြန်ဆန်စွာငွေလွှဲနိုင်ခြင်းမရှိဘဲမြန်မာနိုင်ငံသို့ငွေလွှဲခြင်း',
            'marketing page.this service supports only for burmese citizen': 'ဤ ၀ န်ဆောင်မှုသည်မြန်မာနိုင်ငံသားများအတွက်သာဖြစ် သည်',
            'location page.select state': 'ပြည်နယ်ရှာဖွေရန်',
            'location page.select city': 'မြို့တော်ရွေးချယ်ရန်',
            'location page.select township': 'မြို့နယ်ရွေးချယ်ရန်',
            'nrcinfo.national id number': 'မှတ်ပုံတင်အမှတ်',
            'nrcinfo.region code': 'တိုင်းဒေသ ကုဒ်နံပါတ်',
            'nrcinfo.township code': 'မြို့နယ် ကုဒ်နံပါတ်အတို',
            'nrcinfo.id type': 'ID အမျိုးအစား',
            'nrcinfo.personal id': 'ကိုယ်ပိုင် မှတ်ပုံတင်နံပါတ်',
            'nrcinfo.error select info': 'ကျေးဇူးပြု၍ အချက်အလက်ရွေးပါ',
            'nrcinfo.error 6 digits number only': 'ဂဏန်း 6 လုံးရှိရမည်၊ နံပါတ်များသာ',
        },
    },
    km: {
        translation: {
            'common.country': 'ប្រទេស',
            'country.myanmar': 'ប្រទេសមីយ៉ាន់ម៉ា',
            'country.cambodia': 'ប្រទេសកម្ពុជា',
            'common.international transfer': 'សេវាផ្ទេរប្រាក់ ទ្រូម៉ាន់នី',
            'common.add money': 'ដាក់ប្រាក់',
            'common.maybe later': 'លើកក្រោយ',
            'common.accept': 'យល់ព្រម',
            'common.cancel': 'បោះបង់',
            'common.confirm': 'យល់ព្រម',
            'common.ok': 'យល់ព្រម',
            'common.close': '',
            'common.receiver': 'អ្នកទទួល',
            'common.switch': 'ផ្លាស់ប្តូរ',
            'common.continue': 'បន្ត',
            'common.terms and conditions': 'លក្ខខណ្ឌ',
            'common.receiver details': 'ព័ត៌មានលម្អិតអ្នកទទួល',
            'common.sender details': 'ព័ត៌មានលម្អិតអ្នកផ្ញើ',
            'common.receiver mobile number': 'លេខទូរស័ព្ទអ្នកទទួល',
            'common.mobile number': 'លេខទូរស័ព្ទ',
            'common.fullname': 'ឈ្មោះពេញ',
            'common.fullname (myanmar)': '',
            'common.fullname (english)': 'ឈ្មោះពេញ (អក្សរឡាតាំង)',
            'common.firstname (myanmar)': '',
            'common.lastname (myanmar)': '',
            'common.firstname (english)': 'នាម ឬឈ្មោះ (អក្សរឡាតាំង)',
            'common.lastname (english)': 'គោត្តនាម​​ ឬនាមត្រកូល (អក្សរឡាតាំង)',
            'common.national id number': 'លេខអត្តសញ្ញាណប័ណ្ណជាតិ',
            'common.address': 'អាស័យដ្ឋាន',
            'common.address no., building, road': 'លេខផ្ទះ ឬអាគារ, លេខផ្លូវ',
            'common.state, city, township': 'ក្រុង, ខណ្ឌ ឬស្រុក, សង្កាត់ ឬឃុំ',
            'common.exchange rate': 'អត្រា​ប្តូ​រ​ប្រាក់',
            'common.transfer fee': 'ថ្លៃសេវាផ្ទេរប្រាក់',
            'common.total amount': 'ចំនួនទឹកប្រាក់សរុប',
            'common.error code': 'Error code',
            'common.search': 'ស្វែងរក',
            'common.back to home page': 'ត្រលប់ទៅទំព័រដើម',

            'placeholder.please select': 'សូមជ្រើសរើស',
            'placeholder.enter receiver details': 'បញ្ចូលព័ត៌មានលម្អិតអ្នកទទួល',
            'placeholder.first name (english)': 'នាម ឬឈ្មោះ (អក្សរឡាតាំង)',
            'placeholder.last name (english)': 'គោត្តនាម​​ ឬនាមត្រកូល (អក្សរឡាតាំង)',
            'placeholder.mobile number': 'ត្រូវតែជាលេខ {{from}} ទៅ {{to}} ខ្ទង់',
            'placeholder.myanmar national id number': '',
            'placeholder.cambodia national id number': 'លេខអត្តសញ្ញាណប័ណ្ណជាតិ',

            'validate.required input': ' {{field}}',
            'validate.required select': ' {{field}}',
            'validate.number only': 'Only numeric',
            'validate.cambodia minimum destination amount': 'ចំនួនទឹកប្រាក់មិនអាចតិចជាង {{value}} រៀល',
            'validate.cambodia maximum destination amount': 'ចំនួនទឹកប្រាក់មិនត្រូវលើសពី {{value}} រៀល',
            'validate.cambodia minimum amount': 'ចំនួនទឹកប្រាក់មិនអាចតិចជាង {{value}} បាត',
            'validate.cambodia maximum amount': 'ចំនួនទឹកប្រាក់មិនត្រូវលើសពី {{value}} បាត',
            'validate.myanmar minimum destination amount': 'The amount must not be less than {{value}} MMK',
            'validate.myanmar maximum destination amount': 'The amount must not be over {{value}} MMK',
            'validate.myanmar minimum amount': 'The amount must not be less than {{value}} THB',
            'validate.myanmar maximum amount': 'The amount must not be over {{value}} THB',
            'validate.only english alphabet': 'អាចតែជាអក្សរឡាតាំងតែប៉ុណ្ណោះ',
            'validate.only english alphabet and symbol': 'Only english alphabet and symbol',
            'validation.required digits': 'លេខ {{value}}ខ្ទង់ចុងក្រោយនៃអត្តសញ្ញាណប័ណ្ណជាតិ',
            'validation.required digits between': 'ត្រូវតែជាលេខ {{from}} ទៅ {{to}} ខ្ទង់',

            'notify page.just one more step': '',
            'notify page.if this is your first time using this service, please verify your identity with truemoney transfer staff first': '',
            'notify page.please prepare these documents': '',
            'notify page.your passport': '',
            'notify page.your work permit': '',
            'notify page.chat with staff': '',
            'notify page.search truemoney transfer locations': '',
            'fund in guide page.transferring money to your family is easy, with no fees!':
                'ផ្ទេរប្រាក់ទៅកាន់គ្រួសាររបស់អ្នកបានយ៉ាងងាយស្រួល ឥតគិតថ្លៃសេវា!',
            'fund in guide page.add money to your wallet': 'ដាក់ប្រាក់ចូលទៅក្នុងគណនីអ្នក',
            'fund in guide page.add money': 'ដាក់ប្រាក់',
            'fund in guide page.maybe later': 'លើកក្រោយ',
            'transfer page.wallet balance': 'ទឹកប្រាក់មានក្នុងគណនី',
            'transfer page.add': 'ដាក់ប្រាក់',
            'transfer page.destination country': 'ប្រទេសគោលដៅ',
            'transfer page.amount to receive': 'ចំនួនទឹកប្រាក់ដែលនឹងទទួល',
            'transfer page.amount to send': 'ចំនួនទឹកប្រាក់ដែលត្រូវផ្ញើ',
            'transfer page.the exchange rate may change while making a transaction': 'អត្រាប្តូរប្រាក់អាចផ្លាស់ប្តូរខណៈពេលកំពុងធ្វើប្រតិបត្តិការ',
            'transfer page.transfer purpose': 'គោលបំណងផ្ទេរប្រាក់',
            'transfer page.no transfer fees': 'មិនមានថ្លៃសេវាផ្ទេរប្រាក់',
            'transfer page.you can transfer 50 times per month': 'លោកអ្នកអាចផ្ទេរប្រាក់ចំនួន ៥០ ដងក្នុងមួយខែ',
            'transfer page.money transfer license number': 'លេខអាជ្ញាប័ណ្ណផ្ទេរប្រាក់',
            'document expired page.your verification documents have expired': 'ឯកសារផ្ទៀងផ្ទាត់របស់អ្នកផុតកំណត់ហើយ',
            'document expired page.description':
                'អតិថិជន wallet ត្រូវធ្វើការអាប់ដេតឯកសារនៅលើ TrueMoney wallet ប្រសិនបើឯកសាររបស់គេផុតកំនត់។ សម្រាប់ព័ត៌មានបន្ថែម សូមទាក់ទងទៅកាន់សេវាអតិថិជន 1240',
            'summary page.this amount and exchange rate will be reserved at this step':
                'ចំនួនទឹកប្រាក់ និងអត្រាប្តូរប្រាក់ត្រូវបានរក្សាទុកមុនចូលជំហាននេះ',

            'error page.transfer failed': 'ការផ្ទេរប្រាក់បានបរាជ័យ',
            'error page.we will refund your money to your truemoney wallet immediately. please transfer again.':
                'យើងខ្ញុំនឹងធ្វើការសងប្រាក់របស់អ្នកត្រលប់ទៅទ្រូម៉ាន់នី Wallet របស់អ្នកវិញភ្លាមៗ សូមផ្ទេរប្រាក់ម្តងទៀត។',
            'error page.sorry, the information used for transferring does not meet the criteria to make a transaction. please contact truemoney customer care, call 1240':
                'សូមអភ័យទោស ព័ត៌មានដែលបានប្រើសម្រាប់ផ្ទេរប្រាក់មិនត្រូវបានគោរពតាមលក្ខខណ្ឌដើម្បីធ្វើប្រតិបត្តិការនោះទេ។ សូមធ្វើការទំនាក់ទំនងទៅកាន់ខាងផ្នែកសេវាបំរើអតិថិជនរបស់ទ្រូម៉ាន់នី សូមទូរស័ព្ទទៅលេខ 1240',
            'error maintenance page.system is temporarily unavailable': 'ប្រព័ន្ធមិនដំណើរការបណ្តោះអាសន្ន',
            'error maintenance page.we’re working to fix the problem.we’ll be up and running soon.please try again later.':
                'ពួកយើងកំពុងធ្វើការជួសជុលបញ្ហា។\nពួកយើងនឹងធើ្វឲ្យវាដំណើរការបានវិញឆាប់ៗនេះ។\nសូម​ព្យាយាម​ម្តង​ទៀត​នៅ​ពេល​ក្រោយ។',
            'error maintenance page.sorry, our truemoney transfer service is now temporary unavailable. our service will resume shortly.':
                'ពួកយើងកំពុងធ្វើការជួសជុលបញ្ហា។\nពួកយើងនឹងធើ្វឲ្យវាដំណើរការបានឆាប់ៗនេះ។\nសូម​ព្យាយាម​ម្តង​ទៀត​នៅ​ពេល​ក្រោយ។',
            'error.cannot make a transaction': 'មិនអាចធ្វើប្រតិបត្តិការបាន',
            'error.receiver id is not valid': 'receiver id is not valid',
            'error.transfer amount is over limit':
                'ចំនួនទឹកប្រាក់ដែលផ្ទេរគឺលើសចំនួនដែលបានកំណត់។ សូមធ្វើការផ្ទេរប្រាក់មិនឱ្យលើសពី {{maximumTransferAmount}} បាត ក្នុងមួយដង និងមិនលើសពី {{monthlyLimit}} បាត សរុបក្នុងមួយខែ។',
            'error.reached number of times per month': 'អ្នកបានផ្ទេរប្រាក់ដល់ចំនួនកំណត់',
            'error.can transfer only 50 times per month MM': 'អ្នកអាចផ្ទេរបាន 50 ដងក្នុងមួយខែ។ សូមធ្វើការផ្ទេរប្រេាក់ម្ដងទៀតនៅខែក្រោយ។',
            'error.can transfer only 50 times per month KH': 'អ្នកអាចផ្ទេរបាន 50 ដងក្នុងមួយខែ។ សូមធ្វើការផ្ទេរប្រេាក់ម្ដងទៀតនៅខែក្រោយ។',
            'error version page.unable to process': 'មិនអាចដំណើរការ',
            'error version page.please update TrueMoney Wallet application to the latest version and try to open the app again.':
                'សូមដំឡើងកម្មវិធី TrueMoney Wallet ទៅកាន់ជំនាន់ចុងក្រោយគេ ហើយព្យាយាមបើកកម្មវិធីម្តងទៀត។',
            'error version page.please update the OS of your device and Chrome (if any) to the latest version and try to open the app again.':
                'សូមធ្វើការដំឡើងប្រព័ន្ធប្រតិបត្តិការរបស់ឧបករណ៍អ្នក និង Chrome (ប្រសិនបើមាន) ទៅកាន់ជំនាន់ចុងក្រោយគេបង្អស់ ហើយព្យាយាមបើកកម្មវិធីម្តងទៀត។',

            'error insufficient document page.insufficient document': 'ឯកសារមិនគ្រប់គ្រាន់',
            'error insufficient document page.You need to update new supporting document ! Contact customer care 1240#4 for more information':
                'អ្នកត្រូវការអាប់ដេតឯកសារថ្មី!សូមទាក់ទងទៅកាន់ភ្នាក់ងារសេវាកម្មអតិថិជន 1240#4 សម្រាប់ព័ត៌មានបន្ថែម',
            'error update information page.we need your updated information': 'យើងត្រូវការព័ត៌មានថ្មីៗរបស់អ្នក',
            'error update information page.please contact truemoney customer care at 1240 to update your personal information':
                'សូមទំនាក់ទំនងសេវាបំរើអតិថិជនទ្រូម៉ាន់នីតាមលេខ 1240 ដើម្បីធ្វើបច្ចុប្បន្នភាពព័ត៌មានផ្ទាល់ខ្លួនរបស់អ្នក។',
            'error invalid national id number': 'Invalid National ID Number',
            'error invalid national id number format': 'Please input format 00/xxx(x)000000 For example, 10/NaMaNa(Naing)123456',
            'error value of region code is not valid': 'Region code is not match',
            'error value of region code and region name are not matched': 'Township short code is not match',
            'error value of region name is not valid': 'Township short code is not match',
            'error value of type of ID is not valid': 'Type of ID is not match',
            'error please make sure you have entered correct and complete information to transfer and then try again':
                'សូមប្រាកដថាអ្នកបានបញ្ចូលព័ត៌មានត្រឹមត្រូវ និងពេញលេញដើម្បីផ្ទេរប្រាក់ បន្ទាប់មកព្យាយាមម្តងទៀត.',

            'marketing page.the easiest way to transfer your money in real-time to myanmar with no fees':
                'វិធីងាយស្រួលបំផុតក្នុងការផ្ទេរប្រាក់របស់អ្នកភ្លាមៗ\nទៅកាន់ប្រទេសកម្ពុជា និង ប្រទេសមីយ៉ាន់ម៉ាដោយមិនគិតថ្លៃសេវា',
            'marketing page.this service supports only for burmese citizen': 'សេវាកម្មនេះសម្រាប់តែជនបរទេសប៉ុណ្ណោះ',
            'location page.select state': 'ជ្រើសរើសទីក្រុង',
            'location page.select city': 'ជ្រើសរើសខេត្ត ក្រុង',
            'location page.select township': 'ជ្រើសរើស សង្កាត់ឬឃុំ',
        },
    },
    en: {
        translation: {
            'common.country': 'Country',
            'country.myanmar': 'Myanmar',
            'country.cambodia': 'Cambodia',
            'common.international transfer': 'TrueMoney Transfer',
            'common.add money': 'Add Money',
            'common.maybe later': 'Maybe Later',
            'common.accept': 'Accept',
            'common.cancel': 'Cancel',
            'common.confirm': 'Confirm',
            'common.ok': 'OK',
            'common.close': 'Close',
            'common.switch': 'Switch',
            'common.receiver': 'Receiver',
            'common.continue': 'Continue',
            'common.terms and conditions': 'Terms and Conditions',
            'common.receiver details': 'Receiver details',
            'common.sender details': 'Sender details',
            'common.mobile number': 'Mobile number',
            'common.receiver mobile number': 'Receiver Mobile number',
            'common.fullname': 'Full name',
            'common.fullname (myanmar)': 'Full name (Myanmar)',
            'common.fullname (english)': 'Full name (English)',
            'common.firstname (myanmar)': 'First name (Myanmar)',
            'common.lastname (myanmar)': 'Last name (Myanmar)',
            'common.firstname (english)': 'First name (English)',
            'common.lastname (english)': 'Last name (English)',
            'common.national id number': 'National ID number',
            'common.address': 'Address',
            'common.address no., building, road': 'Address no., Building, Road',
            'common.state, city, township': 'State, City, Township',
            'common.exchange rate': 'Exchange rate',
            'common.transfer fee': 'Transfer fee',
            'common.total amount': 'Total amount',
            'common.error code': 'Error code',
            'common.search': 'Search',
            'common.back to home page': 'Back to Homepage',

            'placeholder.please select': 'Please select',
            'placeholder.enter receiver details': 'Enter receiver details',
            'placeholder.first name (english)': 'All words except last syllable',
            'placeholder.last name (english)': 'Only last syllable',
            'placeholder.mobile number': '{{from}} to {{to}} digits',
            'placeholder.myanmar national id number': 'last 6 digits of National ID',
            'placeholder.cambodia national id number': 'Nation ID',

            'validate.required input': 'Please enter {{field}}',
            'validate.required select': 'Please select {{field}}',
            'validate.number only': 'Only numeric',
            'validate.cambodia minimum destination amount': 'The amount must not be less than {{value}} KHR',
            'validate.cambodia maximum destination amount': 'The amount must not be over {{value}} KHR',
            'validate.cambodia minimum amount': 'The amount must not be less than {{value}} THB',
            'validate.cambodia maximum amount': 'The amount must not be over {{value}} THB',
            'validate.myanmar minimum destination amount': 'The amount must not be less than {{value}} MMK',
            'validate.myanmar maximum destination amount': 'The amount must not be over {{value}} MMK',
            'validate.myanmar minimum amount': 'The amount must not be less than {{value}} THB',
            'validate.myanmar maximum amount': 'The amount must not be over {{value}} THB',

            'validate.only english alphabet': 'Only english alphabet',
            'validate.only english alphabet and symbol': 'Only english alphabet and symbol',
            'validation.required digits': 'Must be {{value}} digits',
            'validation.required digits between': 'Must be {{from}} to {{to}} digits',

            'notify page.just one more step': 'Just one more step',
            'notify page.if this is your first time using this service, please verify your identity with truemoney transfer staff first':
                'If this is your first time using this service, please verify your identity with TrueMoney Transfer staff first.',
            'notify page.please prepare these documents': 'Please prepare these documents:',
            'notify page.your passport': 'Your passport',
            'notify page.your work permit': 'Your work permit',
            'notify page.search truemoney transfer locations': 'Search TrueMoney Transfer Locations',
            'notify page.chat with staff': 'Chat with Staff',
            'fund in guide page.transferring money to your family is easy, with no fees!': 'Transferring money to your family is easy, with no fees!',
            'fund in guide page.add money to your wallet': 'Add money to your wallet.',
            'fund in guide page.add money': 'Add Money',
            'fund in guide page.maybe later': 'Maybe Later',
            'transfer page.wallet balance': 'Wallet balance',
            'transfer page.add': 'Add',
            'transfer page.destination country': 'Destination country',
            'transfer page.amount to receive': 'Amount to receive',
            'transfer page.amount to send': 'Amount to send',
            'transfer page.the exchange rate may change while making a transaction': 'The exchange rate may change while making a transaction',
            'transfer page.transfer purpose': 'Transfer purpose',
            'transfer page.no transfer fees': 'No transfer fees',
            'transfer page.you can transfer 50 times per month': 'You can transfer 50 times per month',
            'transfer page.money transfer license number': 'Money Transfer license number',
            'document expired page.your verification documents have expired': 'Your verification documents have expired',
            'document expired page.description': `Wallet customer must update the documents through TrueMoney wallet only once they're expired. For more information, please contact TrueMoney Customer Care 1240.`,
            'summary page.this amount and exchange rate will be reserved at this step':
                'This amount and exchange rate will be reserved at this step.',

            'error page.transfer failed': 'Transfer failed',
            'error page.we will refund your money to your truemoney wallet immediately. please transfer again.':
                'We will refund your money to your TrueMoney Wallet immediately. Please transfer again.',
            'error page.sorry, the information used for transferring does not meet the criteria to make a transaction. please contact truemoney customer care, call 1240 ext 4.':
                'Sorry, the information used for transferring does not meet the criteria to make a transaction. Please contact TrueMoney Customer Care, Call 1240 Ext 4.',
            'error page.sorry, the information used for transferring does not meet the criteria to make a transaction. please contact truemoney customer care, call 1240':
                'Sorry, the information used for transferring does not meet the criteria to make a transaction. Please contact TrueMoney Customer Care, Call 1240',

            'error maintenance page.system is temporarily unavailable': 'System is temporarily unavailable',
            'error maintenance page.we’re working to fix the problem.we’ll be up and running soon.please try again later.':
                'We’re working to fix the problem.\nWe’ll be up and running soon.\nPlease try again later.',
            'error maintenance page.sorry, our truemoney transfer service is now temporary unavailable. our service will resume shortly.':
                'Sorry, our TrueMoney Transfer service is now temporarily unavailable. Our service will resume shortly.',
            'error.cannot make a transaction': 'Cannot make a transaction',
            'error.receiver id is not valid': 'receiver id is not valid',
            'error.transfer limit amount receiver title': 'Cannot transfer',
            'error.transfer limit amount receiver description':
                'The receiver reaches the maximum amount as specified by the regulation of the destination country (MMK {{limit}} per month). Please make the transaction in the next month.',
            'error.transfer amount is over limit':
                'The transfer amount is over the amount allowed. Please transfer no more than {{maximumTransferAmount}} THB per time and not over {{monthlyLimit}} THB in total per month.',
            'error.reached number of times per month': 'You have reached the number of times you can transfer money ',
            'error.can transfer only 50 times per month MM':
                'You can transfer via TrueMoney Wallet 50 times per month and via TrueMoney Transfer branches 50 times per month. Please come back again next month to proceed.',
            'error.can transfer only 50 times per month KH': 'You can transfer 50 times per month. Please come back again next month to proceed.',
            'error version page.unable to process': 'Unable to process',
            'error version page.please update TrueMoney Wallet application to the latest version and try to open the app again.':
                'Please update TrueMoney Wallet application to the latest version and try to open the app again.',
            'error version page.please update the OS of your device and Chrome (if any) to the latest version and try to open the app again.':
                'Please update the OS of your device and Chrome (if any) to the latest version and try to open the app again.',
            'error insufficient document page.insufficient document': 'Insufficient document',
            'error insufficient document page.You need to update new supporting document ! Contact customer care 1240#4 for more information':
                'You need to update new supporting document ! Contact customer care 1240#4 for more information',

            'error update information page.we need your updated information': 'We need your updated information',
            'error update information page.please contact truemoney customer care at 1240 to update your personal information':
                'Please contact TrueMoney Customer Care at 1240 to update your personal information.',
            'error invalid national id number': 'Invalid National ID Number',
            'error invalid national id number format': 'Please input format 00/xxx(x)000000 For example, 10/NaMaNa(Naing)123456',
            'error value of region code is not valid': 'Region code is not match',
            'error value of region code and region name are not matched': 'Township short code is not match',
            'error value of region name is not valid': 'Township short code is not match',
            'error value of type of ID is not valid': 'Type of ID is not match',
            'error please make sure you have entered correct and complete information to transfer and then try again':
                'Please make sure you have entered correct and complete information to transfer and then try again.',

            'marketing page.the easiest way to transfer your money in real-time to myanmar with no fees':
                'The easiest way to transfer your money in real-time to Myanmar with no fees.',
            'marketing page.this service supports only for burmese citizen': 'This service supports only for Burmese citizen.',
            'location page.select state': 'Select State',
            'location page.select city': 'Select City',
            'location page.select township': 'Select Township',
            'nrcinfo.national id number': 'National ID number',
            'nrcinfo.region code': 'Region code',
            'nrcinfo.township code': 'Township short code',
            'nrcinfo.id type': 'Type of ID',
            'nrcinfo.personal id': 'Personal identification numbers',
            'nrcinfo.confirm button': 'Confirm',
            'nrcinfo.error select info': 'Please select info',
            'nrcinfo.error 6 digits number only': 'Must be 6 digits, number only',
        },
    },
    th: {
        translation: {
            'common.country': 'ประเทศ',
            'country.myanmar': 'พม่า',
            'country.cambodia': 'กัมพูชา',
            'common.international transfer': 'บริการโอนเงินระหว่างประเทศ',
            'common.add money': 'เติมเงิน',
            'common.maybe later': 'ไว้ภายหลัง',
            'common.accept': 'ยินยอม',
            'common.cancel': 'ยกเลิก',
            'common.confirm': 'ยืนยัน',
            'common.ok': 'ตกลง',
            'common.close': 'ปิด',
            'common.switch': 'สลับ',
            'common.receiver': 'ผู้รับ',
            'common.continue': 'ถัดไป',
            'common.terms and conditions': 'ข้อกำหนดและเงื่อนไข',
            'common.receiver details': 'รายละเอียดของผู้รับ',
            'common.sender details': 'รายละเอียดของผู้ส่ง',
            'common.receiver mobile number': 'เบอร์โทรศัพท์ของผู้รับ',
            'common.mobile number': 'เบอร์โทรศัพท์',
            'common.fullname': 'ชื่อสกุล',
            'common.fullname (myanmar)': 'ชื่อสกุล (ภาษาพม่า)',
            'common.fullname (english)': 'ชื่อสกุล (ภาษาอังกฤษ)',
            'common.firstname (myanmar)': 'ชื่อจริง (ภาษาพม่า)',
            'common.lastname (myanmar)': 'นามสกุล (ภาษาพม่า)',
            'common.firstname (english)': 'ชื่อจริง (ภาษาอังกฤษ)',
            'common.lastname (english)': 'นามสกุล (ภาษาอังกฤษ)',
            'common.national id number': 'หมายเลขประจำตัวประชาชน',
            'common.address': 'ที่อยู่',
            'common.address no., building, road': 'บ้านเลขที่, ชื่ออาคาร, ชื่อถนน',
            'common.state, city, township': 'รัฐ, เมือง, ทาวน์ชิป',
            'common.exchange rate': 'อัตราแลกเปลี่ยน',
            'common.transfer fee': 'ค่าธรรมเนียมการโอน',
            'common.total amount': 'จำนวนทั้งสิ้น',
            'common.error code': 'Error code',
            'common.search': 'ค้นหา',
            'common.back to home page': 'กลับสู่หน้าหลัก',

            'placeholder.please select': 'กรุณาเลือก',
            'placeholder.enter receiver details': 'กรอกรายละเอียดของผู้รับ',
            'placeholder.first name (english)': 'All words except last syllable',
            'placeholder.last name (english)': 'Only last syllable',
            'placeholder.mobile number': '{{from}} to {{to}} หลัก',
            'placeholder.myanmar national id number': '6 หลักสุดท้ายของเลขประจำตัว',
            'placeholder.cambodia national id number': 'เลขประจำตัว',

            'validate.required input': 'กรุณากรอก {{field}}',
            'validate.required select': 'กรุณาเลือก {{field}}',
            'validate.number only': 'เฉพาะตัวเลข',
            'validate.cambodia minimum destination amount': 'จำนวนต้องมากกว่่า {{value}} KHR',
            'validate.cambodia maximum destination amount': 'จำนวนต้องไม่เกิน {{value}} KHR',
            'validate.cambodia minimum amount': 'จำนวนต้องมากกว่่า {{value}} บาท',
            'validate.cambodia maximum amount': 'จำนวนต้องไม่เกิน {{value}} บาท',
            'validate.myanmar minimum destination amount': 'จำนวนต้องมากกว่่า {{value}} MMK',
            'validate.myanmar maximum destination amount': 'จำนวนต้องไม่เกิน {{value}} MMK',
            'validate.myanmar minimum amount': 'จำนวนต้องมากกว่่า {{value}} บาท',
            'validate.myanmar maximum amount': 'จำนวนต้องไม่เกิน {{value}} บาท',

            'validate.only english alphabet': 'เฉพาะอักษรภาษาอังกฤษ',
            'validate.only english alphabet and symbol': 'เฉพาะอักษรภาษาอังกฤษและอักขระพิเศษ',
            'validation.required digits': 'กรุณากรอก {{value}} หลัก',
            'validation.required digits between': '{{from}} ถึง {{to}} หลัก',

            'notify page.just one more step': 'อีกเพียงขั้นตอนเดียวเท่านั้น',
            'notify page.if this is your first time using this service, please verify your identity with truemoney transfer staff first':
                'หากคุณใช้บริการนี้เป็นครั้งแรก กรุณายืนยันตัวตนของคุณกับเจ้าหน้าที่ทรูมันนี่ ทรานเฟอร์',
            'notify page.please prepare these documents': 'กรุณาเตรียมเอกสาร ดังนี้',
            'notify page.your passport': 'พาสปอร์ตของคุณ',
            'notify page.your work permit': 'ใบอนุญาตทำงานของคุณ',
            'notify page.search truemoney transfer locations': 'ค้นหาตำแหน่งที่ตั้งของสาขา',
            'notify page.chat with staff': 'คุยกับเจ้าหน้าที่',
            'fund in guide page.transferring money to your family is easy, with no fees!':
                'โอนเงินให้ครอบครัวได้อย่างง่ายดาย แถมยังไม่มีค่าธรรมเนียมอีกด้วย',
            'fund in guide page.add money to your wallet': 'เติมเงินเข้าวอลเล็ทตอนนี้เลย!',
            'fund in guide page.add money': 'เติมเงิน',
            'fund in guide page.maybe later': 'ไว้ภายหลัง',
            'transfer page.wallet balance': 'ยอดเงินที่มี',
            'transfer page.add': 'เติมเงิน',
            'transfer page.destination country': 'ประเทศปลายทาง',
            'transfer page.amount to receive': 'จำนวนที่ต้องได้รับ',
            'transfer page.amount to send': 'จำนวนที่ต้องการโอน',
            'transfer page.the exchange rate may change while making a transaction': 'อัตราแลกเปลี่ยนอาจเปลี่ยนแปลงได้ในขณะทำรายการ',
            'transfer page.transfer purpose': 'จุดประสงค์ในการโอนเงิน',
            'transfer page.no transfer fees': 'ไม่มีค่าธรรมเนียม',
            'transfer page.money transfer license number': 'หมายเลขใบอนุญาตการโอนเงิน',
            'document expired page.your verification documents have expired': 'เอกสารยืนยันตัวตนของคุณหมดอายุแล้ว',
            'document expired page.description':
                'กรุณาอัปเดตเอกสารของคุณผ่านแอปทรูมันนี่ หากต้องการสอบถามข้อมูลเพิ่มเติม กรุณาติดต่อศูนย์บริการลูกค้าทรูมันนี่ โทร.1240',
            'summary page.this amount and exchange rate will be reserved at this step':
                'สงวนสิทธิ์การเปลี่ยนแปลงจำนวนเงินและอัตราแลกเปลี่ยนก่อนดำเนินการถึงขั้นตอนนี้',

            'error page.transfer failed': 'โอนเงินไม่สำเร็จ',
            'error page.we will refund your money to your truemoney wallet immediately. please transfer again.':
                'We will refund your money to your TrueMoney Wallet immediately. Please transfer again.',
            'error page.sorry, the information used for transferring does not meet the criteria to make a transaction. please contact truemoney customer care, call 1240 ext 4.':
                'ขออภัย ข้อมูลการโอนไม่ตรงกับเงื่อนไขในการทำรายการ กรุณาติดต่อ TrueMoney Customer Care โทร.1240 ต่อ 4',
            'error page.sorry, the information used for transferring does not meet the criteria to make a transaction. please contact truemoney customer care, call 1240':
                'ขออภัย ข้อมูลการโอนไม่ตรงกับเงื่อนไขในการทำรายการ กรุณาติดต่อ TrueMoney Customer Care โทร.1240',

            'error maintenance page.system is temporarily unavailable': 'System is temporarily unavailable',
            'error maintenance page.we’re working to fix the problem.we’ll be up and running soon.please try again later.':
                'We’re working to fix the problem.\nWe’ll be up and running soon.\nPlease try again later.',
            'error maintenance page.sorry, our truemoney transfer service is now temporary unavailable. our service will resume shortly.':
                'Sorry, our TrueMoney Transfer service is now temporarily unavailable. Our service will resume shortly.',
            'error.cannot make a transaction': 'ไม่สามารถทำรายการได้',
            'error.receiver id is not valid': 'หมายเลขประจำตัวผู้รับเงินไม่ถูกต้อง',
            'error.transfer limit amount receiver title': 'ไม่สามารถโอนเงิน',
            'error.transfer limit amount receiver description':
                'ผู้รับเงินปลายทางได้รับเงินเกินวงเงินตามเกณฑ์ที่กฎหมายของประเทศผู้รับเงินปลายทางกำหนด (MMK {{limit}} ต่อเดือน) กรุณาทำรายการในเดือนถัดไป',
            'error.transfer amount is over limit':
                'จำนวนเงินโอนเกินกว่าจำนวนที่สามารถทำรายการได้ กรุณาโอนเงินไม่เกิน {{maximumTransferAmount}} บาทต่อครั้ง และไม่เกิน {{monthlyLimit}} บาทต่อเดือน',
            'error version page.unable to process': 'Unable to process',
            'error version page.please update TrueMoney Wallet application to the latest version and try to open the app again.':
                'Please update TrueMoney Wallet application to the latest version and try to open the app again.',
            'error version page.please update the OS of your device and Chrome (if any) to the latest version and try to open the app again.':
                'Please update the OS of your device and Chrome (if any) to the latest version and try to open the app again.',
            'error insufficient document page.insufficient document': 'เอกสารไม่เพียงพอ',
            'error insufficient document page.for more information, please contact trueMoney customer care 1240.':
                'สำหรับข้อมูลเพิ่มเติม กรุณาติดต่อ TrueMoney Customer Care โทร. 1240',

            'error update information page.we need your updated information': 'We need your updated information',
            'error update information page.please contact truemoney customer care at 1240 to update your personal information':
                'Please contact TrueMoney Customer Care at 1240 to update your personal information.',
            'error invalid national id number': 'Invalid National ID Number',
            'error invalid national id number format': 'Please input format 00/xxx(x)000000 For example, 10/NaMaNa(Naing)123456',
            'error value of region code is not valid': 'Region code is not match',
            'error value of region code and region name are not matched': 'Township short code is not match',
            'error value of region name is not valid': 'Township short code is not match',
            'error value of type of ID is not valid': 'Type of ID is not match',
            'error please make sure you have entered correct and complete information to transfer and then try again':
                'Please make sure you have entered correct and complete information to transfer and then try again.',

            'marketing page.the easiest way to transfer your money in real-time to myanmar with no fees': '',
            'marketing page.this service supports only for burmese citizen': '',
            'location page.select state': 'เลือกรัฐ',
            'location page.select city': 'เลือกเมือง',
            'location page.select township': 'เลือกทาวน์ชิป',
        },
    },
};

export default (): void => {
    i18n.use(initReactI18next).init({
        resources,
        lng: getLanguage(),
        fallbackLng: 'en',

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });
};
